import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 25,
  },
  title: {
    color: "#222",
    fontWeight: 'bold',
    fontSize: 18,
    paddingVertical: 10
  },
  subtitle: {
    fontWeight: 'bold',
    fontSize: 16,
    paddingVertical: 10
  },
  listItem: {
    color: "#666",
    fontWeight: 'bold',
    fontSize: 16,
    paddingVertical: 5
  },
  text: {
    color: "#222",
    fontWeight: 'normal',
    fontSize: 16
  }

});
